(function(){
  var plans = Array.prototype.slice.call(document.querySelectorAll('.plan'));
  var one = document.getElementById('onetime');
  if(one && one.dataset.plan === undefined){ one = null; }   /* duo/trio: the single-formula link is not a plan */
  var all = one ? plans.concat([one]) : plans;
  var atc = document.getElementById('atc');
  var ships = document.getElementById('ships');
  var gtee = document.getElementById('gtee');
  var stickAtc = document.getElementById('stick-atc');
  var stickS = document.getElementById('stick-s');
  var policy = ' <a href="/pages/guarantee">Read the policy</a>';
  var gteeText = {
    protocol: 'Covers all three bottles of your first order. Write to us within 12 weeks of delivery for a full refund, and keep whatever is left.',
    monthly: 'Covers your first order, up to three bottles. Write to us within 12 weeks of delivery for a full refund, and keep whatever is left.',
    once: 'Covers your first bottle. Write to us within 12 weeks of delivery for a full refund, and keep whatever is left.'
  };
  var form = document.getElementById('wc-form'), fId = document.getElementById('wc-id'), fPlan = document.getElementById('wc-plan');
  function select(el){
    var plan = el === one ? 'once' : el.dataset.plan;
    fId.value = el.dataset.variant; fPlan.value = el.dataset.sellingPlan || '';
    plans.forEach(function(p){ p.setAttribute('aria-checked', p === el ? 'true' : 'false'); });
    if(one){ one.setAttribute('aria-pressed', el === one ? 'true' : 'false'); }
    atc.textContent = el.dataset.cta;
    stickAtc.textContent = el.dataset.cta;
    stickS.textContent = el.dataset.short;
    ships.textContent = el.dataset.ships;
    gtee.innerHTML = (el.dataset.gtee || gteeText[plan]) + policy;
  }
  all.forEach(function(el){ el.addEventListener('click', function(){ select(el); }); });
  plans.forEach(function(btn, i){
    btn.addEventListener('keydown', function(e){
      var d = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : ((e.key === 'ArrowUp' || e.key === 'ArrowLeft') ? -1 : 0);
      if(!d){ return; }
      e.preventDefault();
      var next = plans[(i + d + plans.length) % plans.length];
      next.focus(); select(next);
    });
  });
  document.getElementById('atc2').addEventListener('click', function(){
    document.querySelector('.plan[data-plan="protocol"]').click();
    window.scrollTo({top:0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  });

  /* gallery */
  var track = document.getElementById('track');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('#thumbs button'));
  var dots = Array.prototype.slice.call(document.querySelectorAll('#dots i'));
  var slides = Array.prototype.slice.call(track.children);
  var smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
  function go(i){
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto'});
  }
  function current(){ return Math.round(track.scrollLeft / track.clientWidth); }
  thumbs.forEach(function(b, i){ b.addEventListener('click', function(){ go(i); }); });
  document.getElementById('prev').addEventListener('click', function(){ go(current() - 1); });
  document.getElementById('next').addEventListener('click', function(){ go(current() + 1); });
  track.addEventListener('keydown', function(e){
    if(e.key === 'ArrowRight'){ e.preventDefault(); go(current() + 1); }
    if(e.key === 'ArrowLeft'){ e.preventDefault(); go(current() - 1); }
  });
  var tick;
  track.addEventListener('scroll', function(){
    clearTimeout(tick);
    tick = setTimeout(function(){
      var i = current();
      thumbs.forEach(function(b, n){ b.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      dots.forEach(function(d, n){ d.className = n === i ? 'on' : ''; });
    }, 90);
  });

  /* sticky buy bar */
  var stick = document.getElementById('stick');
  var buy = document.querySelector('.buy');
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      entries.forEach(function(e){ stick.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, {threshold: 0}).observe(buy);
  }
  stickAtc.addEventListener('click', function(){
    if(form.requestSubmit){ form.requestSubmit(); } else { atc.click(); }
  });

  /* contents rail */
  var links = Array.prototype.slice.call(document.querySelectorAll('.toc a'));
  var secs = links.map(function(a){ return document.querySelector(a.getAttribute('href')); });
  if('IntersectionObserver' in window){
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting){ return; }
        var i = secs.indexOf(e.target);
        links.forEach(function(a, n){ a.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      });
    }, {rootMargin: '-96px 0px -70% 0px'});
    secs.forEach(function(s){ if(s){ obs.observe(s); } });
  }
  links[0].setAttribute('aria-current', 'true');

  /* product card */
  var scrim = document.getElementById('scrim');
  var openC = document.getElementById('open-card');
  var closeC = document.getElementById('close-card');
  function openCard(){
    scrim.hidden = false;
    document.body.style.overflow = 'hidden';
    closeC.focus();
  }
  function closeCard(){
    scrim.hidden = true;
    document.body.style.overflow = '';
    openC.focus();
  }
  openC.addEventListener('click', openCard);
  closeC.addEventListener('click', closeCard);
  scrim.addEventListener('click', function(e){ if(e.target === scrim){ closeCard(); } });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && !scrim.hidden){ closeCard(); } });
  document.getElementById('see-facts').addEventListener('click', function(){
    closeCard();
    var fi = slides.map(function(s){ return s.dataset.slide; }).indexOf('facts');
    go(fi >= 0 ? fi : 4);
    document.querySelector('.gal').scrollIntoView({behavior: smooth ? 'smooth' : 'auto', block: 'center'});
  });
})();
